import { render, staticRenderFns } from "./ListForms.vue?vue&type=template&id=32bdbad0&scoped=true"
import script from "./ListForms.vue?vue&type=script&lang=js"
export * from "./ListForms.vue?vue&type=script&lang=js"
import style0 from "./ListForms.vue?vue&type=style&index=0&id=32bdbad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bdbad0",
  null
  
)

export default component.exports